const productSlugFromUrl = url => {
  if (!url) return undefined;
  const path = url.split(/[?#]/)[0];
  const segments = path.split('/').filter(Boolean);
  return segments[segments.length - 1] || undefined;
};

export default productSlugFromUrl;
